import { render, staticRenderFns } from "./navigation-drawer-menu.vue?vue&type=template&id=50b115a8&scoped=true"
import script from "./navigation-drawer-menu.vue?vue&type=script&lang=ts"
export * from "./navigation-drawer-menu.vue?vue&type=script&lang=ts"
import style0 from "./navigation-drawer-menu.vue?vue&type=style&index=0&id=50b115a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b115a8",
  null
  
)

export default component.exports